import React from 'react';
export var PaginationContext = /*#__PURE__*/React.createContext({
  pagination: {},
  animation: {}
});
export var PaginationContextProvider = PaginationContext.Provider;